import React from 'react';
import { Box } from '@mui/material';

import EmployeeCard from './EmployeeCard';

const EmployeeStatusCardComponent = (props) => {
  const {
    isOffboard,
    allEmpDetails,
    EmployeeDetails,
    ShowErrorMessageDob,
    isHr,
    ShowErrorMessageDoj,
    ShowErrorMessageOEmail,
    ShowErrorMessagePEmail,
    ShowErrorMessagePhoneNo,
    ShowErrorMessage,
    Files,
    allEmployeesDetails,
    handleToggle,
    selectedStatus,
    designationNames,
  } = props;

  return (
    <Box
      sx={{
        width: '100%',
        overflow: 'hidden',
        paddingTop: '2rem',
      }}
    >
      {allEmpDetails.map((employee, index) => (
        <EmployeeCard
          designationNames={designationNames}
          isHr={isHr}
          key={index}
          isOffboard={isOffboard}
          handleToggle={handleToggle}
          selectedStatus={selectedStatus}
          Files={Files}
          employee={employee}
          UpdatedEmployeePhoto={employee?.photoPath}
          allEmployeesDetails={allEmployeesDetails}
          EmployeeDetails={EmployeeDetails}
          ShowErrorMessage={ShowErrorMessage}
          ShowErrorMessageDob={ShowErrorMessageDob}
          ShowErrorMessageDoj={ShowErrorMessageDoj}
          ShowErrorMessagOEmail={ShowErrorMessageOEmail}
          ShowErrorMessagPEmail={ShowErrorMessagePEmail}
          ShowErrorMessagePhoneNo={ShowErrorMessagePhoneNo}
        />
      ))}
    </Box>
  );
};
export default EmployeeStatusCardComponent;
